import apiRequest from './wrapper';

/**
 * @method : GET
 * @path   : /careers/
 * @desc   : get careers
 */
export const getCareers = (pathParam, params) => {
  return new Promise((resolve, reject) => {
    apiRequest('get', '/careers/', { params }, pathParam)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'getSkills: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'getSkills: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'getSkills: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('getSkills: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};

/**
 * @method : GET
 * @path   : /users/me/careers/
 * @desc   : get career recs
 */
export const getRecommendedCareers = (pathParam, params) => {
  return new Promise((resolve, reject) => {
    apiRequest('get', '/users/me/careers/', { params }, pathParam)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'getCareers: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'getCareers: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'getCareers: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('getCareers: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};

/**
 * @method : PUT
 * @path   : /users/me/careers/{soc}
 * @desc   : update career rating
 */
export const updateCareers = (career, rating) => {
  return new Promise((resolve, reject) => {
    apiRequest('put', `/users/me/careers/${career.soc}`, { data: { rating } })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'updateCareers: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'updateCareers: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'updateCareers: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};

/**
 * @method : GET
 * @path   : /api/v2/military-soc/
 * @desc   : search MOC entries by keyword and optional branch
 */
export const searchMilitaryMOC = (keyword, branch) => {
  const params = { keyword };
  if (branch) params.branch = branch;
  return apiRequest('get', '/military-soc/', { params });
};

/**
 * @method : GET
 * @path   : /military-soc/skills
 * @desc   : get skills for a given SOC code (auth required)
 */
export const getMilitaryMOCSkills = (socCode) => {
  return apiRequest('get', '/military-soc/skills', { params: { soc_code: socCode } });
};

/**
 * @method : GET
 * @path   : /careers/{soc}
 * @desc   : get a single career's details (incl. title) by SOC code — used to recover the
 *           civilian occupation title for saved military experience entries, since the
 *           backend only persists occupation_id (the SOC code), never the title.
 */
export const getCareerBySoc = (socCode) => {
  return apiRequest('get', `/careers/${socCode}`);
};

/**
 * @method : GET
 * @path   : /military-soc
 * @desc   : get military SOC occupations
 */
export const getMilitaryCareers = () => {
  return new Promise((resolve, reject) => {
    apiRequest('get', '/military-soc/', {})
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(new Error(`getMilitaryCareers: Error ${error.response.status}`));
        } else if (error.request) {
          reject(new Error('getMilitaryCareers: No response was received from the server'));
        } else {
          reject(error);
        }
      });
  });
};
